import { Entity } from '../../../core/context/entity';

export class Zone extends Entity {
    description: string;
    parentZoneId?: string;
    exposureId?: string;

    constructor({
        id,
        name,
        description,
        parentZoneId,
        exposureId,
    }: {
        id: string;
        name?: string;
        description: string;
        parentZoneId?: string;
        exposureId?: string;
    }) {
        super({ id, name });
        this.description = description;
        this.parentZoneId = parentZoneId;
        this.exposureId = exposureId;
    }
}
